import WorkerStatus from '@/models/Workers/WorkerStatus';

export default class WorkerStatusViewModel {
    name: string;
    value: WorkerStatus;

    public constructor(name: string, value: WorkerStatus) {
        this.name = name;
        this.value = value;
    }
}